<div class="transaction-histories">
	
	<p>
		<b>transaction history</b><br> 
	</p>

	<div class="transaction-history__wrapper">
		{#each transactionHistories as transactionHistory} 
			<p style="display: none;">
				FULLHASH: {transactionHistory.from+transactionHistory.to+transactionHistory.hash+transactionHistory.blockHash}
			</p>
			
			<span>{new Date( transactionHistory.timeStamp * 1000 ).toLocaleString()}</span><br>
		
			<div style="display: flex; margin-bottom: .25rem;">
				<small style="margin-left: .25rem;">from     : {transactionHistory.from} </small><br>
			</div>
			<div style="display: flex; margin-bottom: .25rem;">
				<small style="margin-left: .25rem;">to       : {transactionHistory.to} </small><br>
			</div>
			<div style="display: flex; margin-bottom: .25rem;">
				<small style="margin-left: .25rem;">hash     : {transactionHistory.hash} </small><br>
			</div>
			<div style="display: flex; margin-bottom: .25rem;">
				<small style="margin-left: .25rem;">blockhash: {transactionHistory.blockHash} </small><br>
			</div>
		{/each}
	</div>				
</div>


<script>
	// 渡されてきたやつら
	export let transactionHistories;
	
</script>

<style lang="scss">
	.transaction-histories {
		font-size: initial;
		margin-top: 1.5rem;
		width: fit-content;
		margin-left: auto;
		margin-right: auto;
	}
	.transaction-history__wrapper {
		text-align: left;
		font-size: 10px;
		margin: 1rem auto 0 0;
	}
</style>
